export default new Error('MdHub was not initialized.')
